
var portlet = {

    loadPortlet: function(portlet) {
        portlet.applyLoader(true, "Lade ...");
        connection.getHtmlPart(portlet.attr('data-portlet'), {
            data: {},
            onSuccess: function(data) {
                var content = $('.box-content');
                content.html(data);
                portlet.trigger('loaded');
            },
            onComplete: function() {
                portlet.hideLoader();
            }
        });
    }

};
window.portlet = portlet;

$(document).ready(function() {
    $.each($('[data-portlet]'), function() {
        var p = $(this);
        portlet.loadPortlet(p);
        p.find('[data-box-action]').click(function() {
            switch ($(this).attr('data-box-action')) {
                case 'reload':
                    portlet.loadPortlet(p);
            }
        });
    });
});
